/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createOrganizationPageStyles = makeStyles(() => ({
  wrapperBreadcrumbs: {
    marginBottom: '40px',
  },
  wrapperEditBoxPanel: {
    marginBottom: '40px',
  },
}));
